import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [activeSection, setActiveSection] = useState('home');

  const { pathname } = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // 1. Gérer l'ombre et la taille (classe nav--scrolled)
      if (currentScrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }

      // 2. Cacher au scroll vers le bas / Montrer vers le haut
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsHidden(true); // On descend, on cache
      } else {
        setIsHidden(false); // On remonte, on affiche
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  useEffect(() => {
    if (pathname !== '/') return;
    const sections = ['home', 'work', 'about', 'contact'];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) setActiveSection(entry.target.id);
        });
      },
      { threshold: 0.4 }
    );
    sections.forEach(id => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [pathname]);

  // ---------------------------------------------------------
  // 🎨 CAS N°1 : ON EST SUR UNE PAGE PROJET
  // ---------------------------------------------------------
  if (pathname !== '/') {
    return (
      <nav className={`nav ${isScrolled ? 'nav--scrolled' : ''} ${isHidden ? 'nav--hidden' : ''}`}>
        <Link to="/" className="nav-item">← Portfolio</Link>
        <div className="nav-links">
          {/* Le lien pointe vers la section "#work" de l'accueil */}
          <Link to="/" className="nav-item">projets</Link>
        </div>
      </nav>
    );
  }

  // ---------------------------------------------------------
  // 🏠 CAS N°2 : ON EST SUR LA PAGE D'ACCUEIL ("/")
  // ---------------------------------------------------------
  return (
    <nav className={`nav ${isScrolled ? 'nav--scrolled' : ''} ${isHidden ? 'nav--hidden' : ''}`}>
      <a href="#home" className={`nav-item ${activeSection === 'home' ? 'active' : ''}`}>nathalie liu</a>
      <div className="nav-links">
        <a href="#work" className={`nav-item ${activeSection === 'work' ? 'active' : ''}`}>projets</a>
        <a href="#about" className={`nav-item ${activeSection === 'about' ? 'active' : ''}`}>à propos</a>
        <a href="#contact" className={`nav-item ${activeSection === 'contact' ? 'active' : ''}`}>contact</a>
      </div>
    </nav>
  );
}